import { SearchForm } from "@/component-create/SearchForm"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FORM_ITEM } from "@/components/form/enums"

export function renderMailSearchForm(el: Element) {
  const searchForm = new SearchForm(el, items, { labelWidth: '80px' })

  return searchForm
}

const items = [
  createFormItem('邮件名称', 'mailName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('邮件代码', 'mailCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('邮件主题', 'mailSubject', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
]